var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSurveyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4687 2.89062H23.048C23.4316 2.89063 23.7995 3.02361 24.0707 3.26034C24.3419 3.49706 24.4943 3.81813 24.4943 4.15291V24.9806C24.4943 25.3153 24.3419 25.6364 24.0707 25.8731C23.7995 26.1099 23.4316 26.2428 23.048 26.2428H2.80096C2.4174 26.2428 2.04954 26.1099 1.77832 25.8731C1.50711 25.6364 1.35474 25.3153 1.35474 24.9806V4.15291C1.35474 3.81813 1.50711 3.49706 1.77832 3.26034C2.04954 3.02361 2.4174 2.89063 2.80096 2.89062H7.86273V4.78405H17.9863V2.89062H19.4687Z",
    stroke: "#5470DE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0944 10.4671L9.3095 15.5169H16.5435L10.7557 20.566M7.86328 1H17.9868V4.78685H7.86328V1Z",
    stroke: "#5470DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSurveyIcon);
export default __webpack_public_path__ + "static/media/TotalSurveyIcon.0fc3c902eccf18216b08faceb66675aa.svg";
export { ForwardRef as ReactComponent };